import ReactDOM from 'react-dom/client';
import React from 'react';
import PAGE_COMPONENT from './SingleJobTemplate';
import { Provider as PAGE_CONTEXT } from '../../../contexts/PageContext';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};
ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PAGE_CONTEXT>
);
